/**
 * PaperFormCard — Apple-clean Paper container for paper-form-traceable
 * surfaces. Wraps content in a 1px-bordered, 16px-radius white card on
 * top of the off-white page background.
 *
 * Pattern extracted from RfiForm.jsx redesign (commit 3c68067).
 */

import React from "react";
import { Box, Container, Paper } from "@mui/material";
import { PAGE_BG } from "./styles";

export default function PaperFormCard({
  children,
  maxWidth = "md",
  padding = { xs: 3, md: 5 },
  bgColor = PAGE_BG,
}) {
  return (
    <Box sx={{ bgcolor: bgColor, minHeight: "100vh", pt: 3, pb: 6 }}>
      <Container maxWidth={maxWidth}>
        <Paper
          elevation={0}
          sx={{
            p: padding,
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 3,
            bgcolor: "background.paper",
          }}
        >
          {children}
        </Paper>
      </Container>
    </Box>
  );
}
